import React, { Fragment, Component } from 'react'
import {
    Row, Col,Button, Label,Table
} from "reactstrap"
import classnames from 'classnames'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import { AvForm, AvField, AvGroup, AvCheckboxGroup, AvCheckbox, AvInput } from "availity-reactstrap-validation"
import CustomSelect from '../../../../../helpers/ui/CustomSelect'
import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../../services/apiResponse'

import IndexBloc from '../../Index/Blocs/IndexBloc'
import UpdateBloc from '../Blocs/UpdateBloc'

class WewenangComponent extends Component {

    updateBloc = new UpdateBloc()
    indexBloc = new IndexBloc()
    source
    timer
    constructor(props) {
        super(props)
        this.state = {
            detail: [],
            detailWewenang: [
                {
                    id: 1,
                    desc: '',
                }
            ],
            dataForm: {},
            isLoading: 0,
        }
    }

    addAuth = () => {
        let count = this.state.detailWewenang.length;
        this.setState({
            detailWewenang: [
                ...this.state.detailWewenang,
                {
                    desc : "",
                    id : count == 0 ? (count+1) : this.state.detailWewenang.slice(-1)[0].id + 1
                }
            ]
        })

        console.log(this.state.detailWewenang)
    }

    delAuth = (data) => {
        let count = this.state.detailWewenang.length-1;
        this.setState({
            detailWewenang: [
                ...this.state.detailWewenang.filter((val) => val!=data)
                
                // (count-1)
            ]
        })
    }

    reformatAuth = (raw) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["id"] = data.authority_id;
          newObj["desc"] = data.authority_description;
          return newObj;
        });
    }
    
    handleChangeInputAuth = (e, index) => {
        // 1. Make a shallow copy of the items
        let items = [...this.state.detailWewenang];
        // 2. Make a shallow copy of the item you want to mutate
        let item = {...items[index]};
        // 3. Replace the property you're intested in
        item.desc = e.target.value;
        // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
        items[index] = item;
        // 5. Set the state to our new copy
        this.setState({detailWewenang : items});
    }

    toggle = tab => {
        if(this.state.activeTab !== tab) this.setState({activeTab:tab});
    }

    submitData = async () => {
        await this.updateBloc.fetchUpdateWewenang(this.state.dataForm)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    
    loaddetailWewenang = async () => {
        const query = {
            uuid: this.props.uuid
        }

        await this.updateBloc.fetchAuthority(query)
    }
    

    handlerOnSubmitAuth = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                position_uuid: this.props.uuid,
                ...values
            },
            confirm: true
        })
    }

    componentDidMount() {
        this.loaddetailWewenang()
        // console.log(this.state.detailWewenang)
        
        this.updateBloc.detailWewenangChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log('Wewenang')
                        console.log(response)
                        if (response.length > 0) {
                            this.setState({ detailWewenang: this.reformatAuth(response) })
                        }
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.updateBloc.updateAuthorityChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
        

    }

    componentWillUnmount() {
        this.updateBloc.updateAuthorityChannel?.unsubscribe()
        this.updateBloc.positionInfoChannel?.unsubscribe()
        this.updateBloc.detailWewenangChannel?.unsubscribe()
    }

    render() {
        const { detail, list } = this.state
        return (
            <Fragment>
                <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) => this.handlerOnSubmitAuth(e, values)}
                >
                    <Row className="mb-12">
                        <AvField
                            name="tipe"
                            type="hidden"
                            id="tipe"
                            value="1"
                        />
                        <Table className="table-bordered">
                            <thead className="bg-default" style={{background:'lavender'}}>
                                <tr>
                                    <th>Uraian Wewenang</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                    {
                                this.state.detailWewenang.map((data, index) => {
                                    return (
                                        <div className="row">
                                            <div className="col-md-11">
                                            
                                            <AvField
                                                name={`tugas[${index}]`}
                                                placeholder={`Masukkan Wewenang-${(index+1)}`}
                                                type="text"
                                                errorMessage="Masukkan Uraian Tugas"
                                                className="form-control mb-2"
                                                onChange={(e) => {
                                                    this.handleChangeInputAuth(e, index)
                                                }}
                                                value={data.desc}
                                                validate={{ required: { value: true } }}
                                            />
                                            </div>
                                            <div className="col-md-1 text-right">
                                                {
                                                    index == 0 ? 
                                                    <div className="col-md-2 text-right">
                                                        <Button className="btn-block waves-effect waves-light mb-1 btn btn-dark"
                                                            color="success" 
                                                            type="button"   
                                                            disabled><i className="uil-trash-alt"></i>
                                                        </Button>
                                                    </div> :
                                                        <Button className="btn-block waves-effect waves-light mb-1 btn btn-primary"
                                                            color="danger" 
                                                            type="button"
                                                            onClick={() => {
                                                                this.delAuth(data)
                                                            }}
                                                            ><i className="uil-trash-alt"></i>
                                                        </Button>
                                                }
                                                
                                            </div>
                                        </div>
                                    )    
                                })
                            }
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td>
                                    <Button className="btn-block waves-effect waves-light mb-1 btn btn-primary"
                                        color="success" 
                                        type="button"
                                        onClick={this.addAuth}
                                        ><i className="uil-plus-circle"></i>Tambah
                                    </Button>
                                    </td>
                                </tr>
                            </tfoot>
                        </Table>
                        <AvField
                            name="authority_position_uuid"
                            type="hidden"
                            value={this.props.uuid}
                            // validate={{ required: { value: true } }}
                            readOnly={true}
                        />
                        
                    </Row>
                    <Row className="mb-3" style={{padding:'25px'}}>
                        <Col md="3"></Col>
                        <Col md="9">
                            <Link to="/master/syarat_jabatan.html">
                                <Button color="danger" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                            </Link>
                            {' '}
                            <Button color="success" type="submit">
                                <i className="uil-arrow-up-right"></i> Simpan Data
                            </Button>
                        </Col>
                    </Row>
                </AvForm>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    null// <Redirect to='/master/syarat_jabatan.html'/>
                : null }
            </Fragment>
        )
    }


}

export default WewenangComponent
